var module = angular.module('odetManager', []);

module.factory('odetManager', ['$q', 'curriculumManager', 'settings', 'sriClient', '$location', function ($q, curriculumManager, settings, sriClient, $location) {
  'use strict';
  var that = {};
  var curr = $q.defer();
  var curriculumPromise = curr.promise;
  var goalMap = {};
  var concordantiesMapZillOdet = {};
  var concordantiesMapOdetZill = {};
  var currHash;

  var getOdetByHref = function (href, url) {
    var d = $q.defer();
    var hashTimestamp = '';
    if ($location.search().preview) {
      hashTimestamp = '?t=' + Math.round(+new Date() / 1000);
    }
    sriClient.get(href + '/hash' + hashTimestamp, {}, {baseUrl: url}).then(function (result) {
      currHash = result.hash + '-' + curriculumManager.getCurrHash();
      sriClient.getAll(
        '/content',
        {
          typeIn: 'CURRICULUM_ODET,CURRICULUM_ODET_LEVEL,CURRICULUM_ODET_LEERGEBIED,CURRICULUM_ODET_SUBSECTION,CURRICULUM_ODET_DEVELOPMENT_GOAL,CURRICULUM_ODET_ENDTERM,CURRICULUM_ODET_CONTENT_GROUP,CURRICULUM_ODET_CONTENT',
          root: href,
          limit: 6000
        },
        {
          baseUrl: url,
          headers: {
            'VSKO-Resource-Hash': currHash
          }
        }
      ).then(function (results) {
        sriClient.get(href, {}, {baseUrl: url}).then(function (root) {
          results.unshift(root);
          d.resolve(results);
        });
      });
    }, function (errors) {
      d.reject(errors);
    });
    return d.promise;
  };

  var findChildInList = function (relation, list) {
    var key = relation.from.href.split('/')[relation.from.href.split('/').length - 1];
    var child = list[key];
    if(child) {
      child.readorder = relation.readorder;
    } else {
      //console.warn('Relation not found: ' + relation.$$meta.permalink)
    }
    return child;
  };
  var sortListOnReadOrder = function (list) {
    list.sort(function (a, b) {
      return a.readorder - b.readorder;
    });
  };

  var topSubsection = function (item) {
    var toReturn = null;
    if (item.subsection) {
      if (item.subsection.subsection) {
        toReturn = topSubsection(item.subsection);
      } else {
        toReturn = item.subsection;
      }
    } else {
      toReturn = null;
    }
    return toReturn;
  };

  var calcGoalCode = function (goal) {
    var code;
    var leergebiedCode;
    var domainCode;
    var goalCode;
    if(goal.leergebied) {
      leergebiedCode = goal.leergebied.code;
    }
    if(goal.domain && goal.domain.identifiers && goal.domain.identifiers.length > 0) {
      domainCode = goal.domain.identifiers[0];
    }
    if(goal.identifiers && goal.identifiers.length > 0) {
      goalCode = goal.identifiers[0];
    }
    if(domainCode && !goalCode) {
      code = leergebiedCode + ' ' + domainCode;
    }else if(leergebiedCode && domainCode) {
      code = leergebiedCode + ' ' + domainCode + '.' + goalCode;
    }else if(!domainCode && goalCode) {
      code = leergebiedCode + ' ' + goalCode;
    }
    return code;
  };

  /**
   * Method to be called on startup of the application that will prepare the
   * odet in an ordered tree and cache it here;
   * Convert array of results to an ordered tree;
   */
  var typeMap;
  that.prepareCurriculum = function (url) {
    if(typeof url === 'undefined') {
      url = settings.apisAndUrls.api;
    }
    curriculumManager.getCurrentCurriculumRoot().then(function (currentCurr) {
      var i, odetHref;
      for (i in currentCurr.$$relationsFrom) {
        if (currentCurr.$$relationsFrom[i].$$expanded.relationtype === 'IS_VERSION_OF') {
          odetHref = '/content/' + currentCurr.$$relationsFrom[i].$$expanded.to.href.split('/')[currentCurr.$$relationsFrom[i].$$expanded.to.href.split('/').length - 1];
        }
      }
      if(odetHref) {
        getOdetByHref(odetHref, url).then(function (results) {
          console.time('Building Tree ODET');
          var curriculum, i, part;
          typeMap = {
            CURRICULUM_ODET: [],
            CURRICULUM_ODET_LEVEL: [],
            CURRICULUM_ODET_LEERGEBIED: [],
            CURRICULUM_ODET_SUBSECTION: [],
            CURRICULUM_ODET_DEVELOPMENT_GOAL: [],
            CURRICULUM_ODET_ENDTERM: [],
            CURRICULUM_ODET_CONTENT_GROUP: [],
            CURRICULUM_ODET_CONTENT: []
          };

          curriculumManager.getCurriculum().then(function () {
            for (i = 0; i < results.length; i++) {
              part = results[i];

              if (part.type === 'CURRICULUM_ODET') {
              //if type CURRICULUM_ODET == curriculum
                curriculum = part;
              } else if (typeMap.hasOwnProperty(part.type)) {
              //add resource to right map
                typeMap[part.type][part.key] = part;
              } else {
                console.warn('UNKNOWN ODET curriculum type: ' + part.type);
              }
            }

            var level, leergebied, simpleLevel, simpleLeergebied;
            var j;

            //LEVELS
            curriculum.levels = [];
            for (i = 0; i < curriculum.$$relationsTo.length; i++) {
              level = findChildInList(curriculum.$$relationsTo[i].$$expanded, typeMap.CURRICULUM_ODET_LEVEL);
              if(level) {
                curriculum.levels.push(level);
                simpleLevel = angular.extend(level);
                level.leergebieden = [];
                if(!concordantiesMapZillOdet[level.key]) {
                  concordantiesMapZillOdet[level.key] = {};
                }
                if(!concordantiesMapOdetZill[level.key]) {
                  concordantiesMapOdetZill[level.key] = {};
                }

                //LEERGEBIEDEN
                for (j = 0; j < level.$$relationsTo.length; j++) {
                  leergebied = findChildInList(level.$$relationsTo[j].$$expanded, typeMap.CURRICULUM_ODET_LEERGEBIED);
                  if(leergebied) {
                    leergebied.code = leergebied.identifiers ? leergebied.identifiers[0] : '';
                    leergebied.level = simpleLevel;
                    simpleLeergebied = angular.extend(leergebied);
                    level.leergebieden.push(leergebied);

                    //SUBSECTIONS && GOALS
                    handleSubsections(leergebied, simpleLeergebied, 'leergebied', level.key);
                  }
                }
                sortListOnReadOrder(level.leergebieden);
              }
            }
            sortListOnReadOrder(curriculum.levels);
            console.timeEnd('Building Tree ODET');
            curr.resolve(curriculum);
          });
        });
      }else{
        console.warn('No odet relations found');
      }
    });
  };

  function handleGoals(item, simpleItem, prev, part) {
    var k, goal, l;
    var preZero = '00';
    item.goals = [];

    for (k = 0; k < item.$$relationsTo.length; k++) {

      goal = findChildInList(item.$$relationsTo[k].$$expanded, typeMap.CURRICULUM_ODET_DEVELOPMENT_GOAL);
      if (!goal) {
        goal = findChildInList(item.$$relationsTo[k].$$expanded, typeMap.CURRICULUM_ODET_ENDTERM);
      }

      if (goal) {
        item.goals.push(goal);
        goalMap[goal.key] = goal;
        if(prev === 'leergebied') {
          goal.leergebied = simpleItem;
        }else{
          goal[prev] = simpleItem;
          goal.leergebied = item.leergebied;
        }
        goal.domain = topSubsection(goal);
        goal.code = calcGoalCode(goal);
        if (!goal.domain) {
          goal.sort = parseInt(goal.leergebied.level.readorder +
            (preZero + goal.leergebied.readorder).slice(-preZero.length) +
            preZero +
            (preZero + goal.readorder).slice(-preZero.length));
        } else {
          goal.sort = parseInt(goal.domain.leergebied.level.readorder +
            (preZero + goal.domain.leergebied.readorder).slice(-preZero.length) +
            (preZero + goal.domain.readorder).slice(-preZero.length) +
            (preZero + goal.readorder).slice(-preZero.length));
        }
        //Add to concordanties map
        for (l = 0; l < goal.$$relationsTo.length; l++) {
          if (goal.$$relationsTo[l].$$expanded.relationtype === 'IS_VERSION_OF') {
            if (!concordantiesMapZillOdet[part][goal.$$relationsTo[l].$$expanded.from.href.split('/')[goal.$$relationsTo[l].$$expanded.from.href.split('/').length - 1]]) {
              concordantiesMapZillOdet[part][goal.$$relationsTo[l].$$expanded.from.href.split('/')[goal.$$relationsTo[l].$$expanded.from.href.split('/').length - 1]] = [];
            }
            concordantiesMapZillOdet[part][goal.$$relationsTo[l].$$expanded.from.href.split('/')[goal.$$relationsTo[l].$$expanded.from.href.split('/').length - 1]].push(goal);

            if (!concordantiesMapOdetZill[part][goal.key]) {
              concordantiesMapOdetZill[part][goal.key] = [];
            }
            var zillGoal = curriculumManager.getSelectionDirect('/content/' + goal.$$relationsTo[l].$$expanded.from.href.split('/')[goal.$$relationsTo[l].$$expanded.from.href.split('/').length - 1]);
            if(zillGoal) {
              concordantiesMapOdetZill[part][goal.key].push(zillGoal);
            }
          }
        }
      }

    }

    if (item.goals.length === 0) {
      delete item.goals;
    } else {
      sortListOnReadOrder(item.goals);
    }

  }

  function handleSubsections(leergebied, simpleLeergebied, prev, part) {

    var k, subsection, simpleSubsection;
    leergebied.subsections = [];

    for (k = 0; k < leergebied.$$relationsTo.length; k++) {

      subsection = findChildInList(leergebied.$$relationsTo[k].$$expanded, typeMap.CURRICULUM_ODET_SUBSECTION);

      if (subsection) {
        subsection[prev] = simpleLeergebied;
        simpleSubsection = angular.extend(subsection);
        leergebied.subsections.push(subsection);
        if (prev === 'subsection') {
          subsection.leergebied = leergebied.leergebied;
        }
        handleSubsections(subsection, simpleSubsection, 'subsection', part);
      }

    }

    if (leergebied.subsections.length === 0) {
      delete leergebied.subsections;
      handleGoals(leergebied, simpleLeergebied, prev, part);
    } else {
      sortListOnReadOrder(leergebied.subsections);
    }

  }

  /**
   * Returns the cached curriculum tree as a promise;
   */
  that.getCurriculum = function () {
    return curriculumPromise;
  };

  that.getGoalByKey = function (key) {
    var d = $q.defer();
    curriculumPromise.then(function () {
      var toReturn = goalMap[key];
      if (!toReturn) {
        toReturn = [];
      }
      d.resolve(toReturn);
    });

    return d.promise;
  };

  that.getConcordantieByZill = function (part, key) {
    var d = $q.defer();
    curriculumPromise.then(function () {
      var toReturn = concordantiesMapZillOdet[part][key];
      if (!toReturn) {
        toReturn = [];
      }
      d.resolve(toReturn);
    });

    return d.promise;
  };

  that.getConcordantieByZillGoal = function (part, key) {
    var d = $q.defer();

    curriculumPromise.then(function () {

      if (concordantiesMapZillOdet[part][key]) {
        var toReturn = concordantiesMapZillOdet[part][key];
      } else {
        var toReturn = [];
      }

      curriculumManager.getGoalByHref('/content/' + key).then(function (goal) {
        if(goal && goal.contentGroups) {
          goal.contentGroups.forEach(function (contentGroup) {
            if(contentGroup.content1s) {
              contentGroup.content1s.forEach(function (content1) {
                if(concordantiesMapZillOdet[part][content1.key]) {
                  concordantiesMapZillOdet[part][content1.key].forEach(function (conc) {
                    toReturn.push(conc);
                  });
                }
                if(content1.content2s) {
                  content1.content2s.forEach(function (content2) {
                    if(concordantiesMapZillOdet[part][content2.key]) {
                      concordantiesMapZillOdet[part][content2.key].forEach(function (conc) {
                        toReturn.push(conc);
                      });
                    }
                  });
                }
              });
            }
          });
        }
        d.resolve(_.sortBy(_.uniq(toReturn), ['sort']));
      });

    });

    return d.promise;
  };


  that.getConcordantieByOdet = function (part, key) {
    var d = $q.defer();
    curriculumPromise.then(function () {
      var toReturn = concordantiesMapOdetZill[part][key];
      if (!toReturn) {
        toReturn = [];
      }
      d.resolve(toReturn);
    });
    return d.promise;
  };

  that.getCurrHash = function () {
    return currHash;
  };

  that.getNext = function (itemKey) {
    var d = $q.defer();
    that.getGoalByKey(itemKey).then(function (item) {
      var parent;
      if(item.domain) {
        parent = item.domain;
      } else {
        parent = item.leerinhoud;
      }
      var goals = [];
      function addGoals(toAdd) {
        if (toAdd.subsections) {
          toAdd.subsections.forEach(addGoals);
        } else {
          toAdd.goals.forEach(function (goal) {
            goals.push(goal);
          });
        }
      }
      addGoals(parent);
      var index = _.findIndex(goals, {key: item.key});
      var next = goals[index + 1];
      if (!next) {
        next = goals[0];
      }
      d.resolve(next);
    });
    return d.promise;
  };

  that.getPrev = function (itemKey) {
    var d = $q.defer();
    that.getGoalByKey(itemKey).then(function (item) {
      var parent;
      if(item.domain) {
        parent = item.domain;
      } else {
        parent = item.leerinhoud;
      }
      var goals = [];
      function addGoals(toAdd) {
        if (toAdd.subsections) {
          toAdd.subsections.forEach(addGoals);
        } else {
          toAdd.goals.forEach(function (goal) {
            goals.push(goal);
          });
        }
      }
      addGoals(parent);
      var index = _.findIndex(goals, {key: item.key});
      var prev = goals[index - 1];
      if (!prev) {
        prev = goals[goals.length - 1];
      }
      d.resolve(prev);
    });
    return d.promise;
  };

  return that;
}]);

module.exports = module;



// WEBPACK FOOTER //
// ./web/js/module/vsko-odet-manager/js/odetManager.js